<template>
  <div
    class="w-full h-screen flex flex-col justify-center items-center gap-3 overflow-hidden"
  >
    <div class="flex flex-col justify-center items-center gap-2">
      <img src="./../assets/logo.png" alt="" class="w-[80px]" />
      <h1 class="font-bold">Login via Telegram</h1>
    </div>
    <vue-qrcode
      class="rounded-xl"
      :value="`https://t.me/Meng0xBot?start=${this.token}`"
      type="image/png"
      :color="{
        dark: '#efefef',
        light: '#1f1f1f',
      }"
      :quality="1"
      :width="220"
      :margin="4"
      :scale="4"
    ></vue-qrcode>
    <div class="text-xs">
      Scan QR Code or
      <a
        :href="`https://t.me/Meng0xBot?start=${this.token}`"
        target="_blank"
        class="text-blue-500 hover:underline"
      >
        click to here
      </a>
    </div>
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "LoginView",
  components: { VueQrcode },
  data() {
    return {
      token: null,
      interval: null,
    };
  },
  beforeMount() {
    this.token = uuidv4();
    this.$store.commit("auth/setToken", this.token);
    this.interval = setInterval(async () => {
      await this.$store.dispatch("auth/checkAuth");
      if (this.$store.getters["auth/isAuthenticated"]) {
        clearInterval(this.interval);
        this.$router.push(this.$route.query.redirect ?? "/");
      }
    }, 3000);
  },
  beforeUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
};
</script>
